"use client";

import React, { useState } from "react";
import { motion } from "framer-motion";
import { IoIosArrowBack } from "react-icons/io";
import CargoService from "../../../services/Cargo";
import { useDispatch } from "react-redux";
import { showToast } from "../../../redux/slices/toastSlice";
import { useParams } from "react-router";
import { AnimatePresence } from "framer-motion";
import Toast from "../../../Modals/toast/Toast";

const containerVariants = {
  hidden: { opacity: 0, y: 8 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      when: "beforeChildren",
      staggerChildren: 0.06,
      duration: 0.36,
    },
  },
};

const itemVariant = {
  hidden: { opacity: 0, y: 8 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.28, ease: "easeOut" } },
};

const Report = ({setView}) => {
  const id=useParams().id
  const [loadingBtn,setLoadingBtn]=useState(false)
  const [title,setTitle]=useState(null)
  const [desc,setDesc]=useState(null)
  const dispatch=useDispatch()
  const [showNotif, setShowNotif] = useState(false);

    async function sendReport() {
        setLoadingBtn(true);
        try {
            const body = {
                title: title,
                description: desc,
                cargo: id,
            };
            const res = await CargoService.report(body);

            if (res.status >= 200 && res.status < 300) {
                setTitle("");
                setDesc("");     
                dispatch(showToast({message: "گزارش با موفقیت ثبت شد" , type:"success" }))     
                setTimeout(() => {
                    setShowNotif(false);
                    setView("load");
                }, 1000);
            }
        } catch (err) {
          dispatch(showToast({message: err?.data?.data?.message || "خطا در ارسال گزارش" , type:"error" }))
            console.log(err);
        } finally {
            setLoadingBtn(false);
        }
    }


    return (
      <>
      <Toast></Toast>
    <div className="w-full lg:justify-center flex flex-col gap-10 min-h-screen py-10 lg:px-10 px-5" dir="rtl">
        <AnimatePresence>
       
        </AnimatePresence>
         <div onClick={()=>{setView("load")}} className="lg:flex hidden gap-1 justify-end cursor-pointer hover:scale-105 transition-all duration-200 text-special text-md">
            <p >بازگشت</p>
            <IoIosArrowBack className='text-special' strokeWidth={1} size={20} ></IoIosArrowBack>
        </div>
    <motion.div
      className="w-full flex lg:items-center gap-10 py-10 lg:px-10 px-5 flex-col lg:flex-row xl:justify-between"
      dir="rtl"
      initial="hidden"
      animate="visible"
      variants={containerVariants}
    >
         <div onClick={()=>{setView("load")}} className="lg:hidden flex gap-1 justify-end cursor-pointer hover:scale-105 transition-all duration-200 text-special text-md">
            <p >بازگشت</p>
            <IoIosArrowBack className='text-special' strokeWidth={1} size={20} ></IoIosArrowBack>
        </div>


      <motion.div
        variants={itemVariant}
        className="flex flex-col gap-8 justify-center items-start w-full lg:w-1/3"
      >
        <h2 className="text-special text-[20px] font-semibold">ثبت تخلف</h2>
        <p className="text-[16px] text-gray-800 leading-relaxed">
          ما اینجا هستیم تا به سؤالات شما پاسخ دهیم و به شما کمک کنیم. لطفاً فرم را پر کنید یا از اطلاعات تماس مستقیم ما استفاده نمایید.
        </p>
      </motion.div>

  
      <motion.div
        variants={itemVariant}
        className="flex flex-col gap-4 justify-start items-start w-full lg:w-2/3 xl:w-1/2 px-6 lg:px-10 py-8 bg-special rounded-3xl"
      >
        <motion.div variants={itemVariant} className="flex flex-col gap-3 items-start justify-start w-full">
          <label className="text-white text-[16px]">موضوع</label>
          <input
            type="text"
            onChange={(e)=>setTitle(e.target.value)}
            className="w-full h-11 lg:h-[45px] rounded-xl px-3 py-1 text-black"
            placeholder="موضوع"
            aria-label="موضوع"
          />
        </motion.div>

        <motion.div variants={itemVariant} className="flex flex-col gap-3 items-start justify-start w-full">
          <label className="text-white text-[16px]">متن پیام</label>
          <textarea
           onChange={(e)=>setDesc(e.target.value)}
            className="w-full h-36 lg:h-[150px] rounded-xl px-3 py-2 text-black resize-vertical"
            placeholder="متن خود را بنویسید ..."
            aria-label="متن پیام"
          />
        </motion.div>

        <motion.div variants={itemVariant} className="flex justify-center items-center w-full">
          <motion.button
          onClick={sendReport}
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            transition={{ type: "spring", stiffness: 400, damping: 18 }}
            className="text-white border-[1px] border-white h-11 lg:h-[45px] w-[130px] rounded-xl bg-transparent"
          >
            {
              loadingBtn?
              'منتظر بمانید...'
              :
              'ثبت'
            }

          </motion.button>
        </motion.div>
      </motion.div>
    </motion.div>
    </div>
    </>
  );
};

export default Report;
